/**
 * The standard colors available to designs in Ursa a.k.a. New Views a.k.a. Smartsheet Design
 * System. This file was generated by Style Dictionary in the @smartsheet/design-tokens package.
 */

export const colors = {
  focus: "#1F66FF",
  // blue400 hardcoded
  linkDark: "#0F3B99",
  // blue700 hardcoded
  linkDefault: "#1957DE",
  // blue500 hardcoded
  neutral25: "#f5f6fa",
  neutral35: "#eef0f6",
  neutral50: "#e5e7f0",
  neutral60: "#dcdeea",
  neutral75: "#d0d3e2",
  neutral100: "#b8bdd1",
  neutral200: "#a6acc4",
  neutral300: "#8d94b0",
  neutral400: "#6b7394",
  neutral500: "#5f6786",
  neutral600: "#4c5470",
  neutral700: "#363c54",
  neutral800: "#212536",
  neutral900: "#11131d",
  neutral00: "#ffffff",
  slate25: "#f5f6fa",
  slate35: "#eef0f6",
  slate50: "#e5e7f0",
  slate60: "#dcdeea",
  slate75: "#d0d3e2",
  slate100: "#b8bdd1",
  slate200: "#a6acc4",
  slate300: "#8d94b0",
  slate400: "#6b7394",
  slate500: "#5f6786",
  slate600: "#4c5470",
  slate700: "#363c54",
  slate800: "#212536",
  slate900: "#11131d",
  red25: "#fff5f6",
  red35: "#ffebed",
  red50: "#ffe0e3",
  red60: "#fed7da",
  red75: "#fbc6c9",
  red100: "#f7abb0",
  red200: "#f29298",
  red300: "#e96d75",
  red400: "#df2a36",
  red500: "#ce1723",
  red600: "#ab0d17",
  red700: "#7f050d",
  red800: "#570006",
  red900: "#330003",
  pink25: "#fff5fa",
  pink35: "#ffebf6",
  pink50: "#fee1f2",
  pink60: "#fdd3ec",
  pink75: "#fdc4e4",
  pink100: "#f9a4d6",
  pink200: "#f589c8",
  pink300: "#e76ab3",
  pink400: "#ce3b91",
  pink500: "#b53680",
  pink600: "#992468",
  pink700: "#73114a",
  pink800: "#4c062f",
  pink900: "#2e001c",
  rose25: "#fff5fa",
  rose35: "#ffebf6",
  rose50: "#fee1f2",
  rose60: "#fdd3ec",
  rose75: "#fdc4e4",
  rose100: "#f9a4d6",
  rose200: "#f589c8",
  rose300: "#e76ab3",
  rose400: "#ce3b91",
  rose500: "#b53680",
  rose600: "#992468",
  rose700: "#73114a",
  rose800: "#4c062f",
  rose900: "#2e001c",
  orchid25: "#fdf5ff",
  orchid35: "#fcebff",
  orchid50: "#f8ddfd",
  orchid60: "#f5d0fb",
  orchid75: "#f0c3f8",
  orchid100: "#e5a7f1",
  orchid200: "#db91e8",
  orchid300: "#ce73de",
  orchid400: "#b53dcc",
  orchid500: "#a531b9",
  orchid600: "#8b259d",
  orchid700: "#661575",
  orchid800: "#41064b",
  orchid900: "#27002d",
  violet25: "#f8f5ff",
  violet35: "#f5f0ff",
  violet50: "#ebe0ff",
  violet60: "#e0d1ff",
  violet75: "#d6c2ff",
  violet100: "#c9adff",
  violet200: "#bb99ff",
  violet300: "#a87efb",
  violet400: "#8959e8",
  violet500: "#7847dc",
  violet600: "#6329d6",
  violet700: "#440fae",
  violet800: "#26026e",
  violet900: "#160042",
  indigo25: "#f8f5ff",
  indigo35: "#f5f0ff",
  indigo50: "#ebe0ff",
  indigo60: "#e0d1ff",
  indigo75: "#d6c2ff",
  indigo100: "#c9adff",
  indigo200: "#bb99ff",
  indigo300: "#a87efb",
  indigo400: "#8959e8",
  indigo500: "#7847dc",
  indigo600: "#6329d6",
  indigo700: "#440fae",
  indigo800: "#26026e",
  indigo900: "#160042",
  blue25: "#f5f8ff",
  blue35: "#ebf1ff",
  blue50: "#dbe6ff",
  blue60: "#c7d8ff",
  blue75: "#b8cdff",
  blue100: "#9ebbff",
  blue200: "#80a6ff",
  blue300: "#6692fa",
  blue400: "#3a6fe9",
  blue500: "#2d60d7",
  blue600: "#184bc3",
  blue700: "#0d3491",
  blue800: "#031c59",
  blue900: "#000f33",
  azure25: "#ebfaff",
  azure35: "#d8f5fd",
  azure50: "#c6effa",
  azure60: "#b6e8f7",
  azure75: "#98dcf1",
  azure100: "#6acae7",
  azure200: "#3ab9df",
  azure300: "#1ea0c8",
  azure400: "#157e9d",
  azure500: "#10718e",
  azure600: "#0b5c75",
  azure700: "#064355",
  azure800: "#022a36",
  azure900: "#001f33",
  aqua25: "#e8fdf9",
  aqua35: "#d2f9f1",
  aqua50: "#b5f2e6",
  aqua60: "#9cecdc",
  aqua75: "#86e4d1",
  aqua100: "#5ad3bb",
  aqua200: "#30c0a3",
  aqua300: "#28a98f",
  aqua400: "#1c826d",
  aqua500: "#167461",
  aqua600: "#0f6151",
  aqua700: "#084438",
  aqua800: "#042a23",
  aqua900: "#001a17",
  teal25: "#e8fdf9",
  teal35: "#d2f9f1",
  teal50: "#b5f2e6",
  teal60: "#9cecdc",
  teal75: "#86e4d1",
  teal100: "#5ad3bb",
  teal200: "#30c0a3",
  teal300: "#28a98f",
  teal400: "#1c826d",
  teal500: "#167461",
  teal600: "#0f6151",
  teal700: "#084438",
  teal800: "#042a23",
  teal900: "#001a17",
  mint25: "#e7fdeb",
  mint35: "#d2f9d8",
  mint50: "#b9f4c3",
  mint60: "#a1edad",
  mint75: "#8ee69d",
  mint100: "#62d574",
  mint200: "#32c84c",
  mint300: "#29ae40",
  mint400: "#1d862f",
  mint500: "#177827",
  mint600: "#0f621c",
  mint700: "#094814",
  mint800: "#042f0a",
  mint900: "#081a00",
  green25: "#e7fdeb",
  green35: "#d2f9d8",
  green50: "#b9f4c3",
  green60: "#a1edad",
  green75: "#8ee69d",
  green100: "#62d574",
  green200: "#32c84c",
  green300: "#29ae40",
  green400: "#1d862f",
  green500: "#177827",
  green600: "#0f621c",
  green700: "#094814",
  green800: "#042f0a",
  green900: "#081a00",
  yellow25: "#fff6e0",
  yellow35: "#fff0cc",
  yellow50: "#fde6af",
  yellow60: "#fbda8d",
  yellow75: "#f9cd67",
  yellow100: "#efb32a",
  yellow200: "#dea41b",
  yellow300: "#bf8e1d",
  yellow400: "#966e13",
  yellow500: "#88620c",
  yellow600: "#705006",
  yellow700: "#543b03",
  yellow800: "#322301",
  yellow900: "#1a1200",
  gold25: "#fff6e0",
  gold35: "#fff0cc",
  gold50: "#fde6af",
  gold60: "#fbda8d",
  gold75: "#f9cd67",
  gold100: "#efb32a",
  gold200: "#dea41b",
  gold300: "#bf8e1d",
  gold400: "#966e13",
  gold500: "#88620c",
  gold600: "#705006",
  gold700: "#543b03",
  gold800: "#322301",
  gold900: "#1a1200",
  orange25: "#fff6f5",
  orange35: "#ffeeeb",
  orange50: "#ffe1dc",
  orange60: "#fed5cd",
  orange75: "#fec8be",
  orange100: "#fda796",
  orange200: "#fb8f79",
  orange300: "#f06b51",
  orange400: "#d64529",
  orange500: "#b84028",
  orange600: "#973421",
  orange700: "#732111",
  orange800: "#4c1106",
  orange900: "#2d0800"
};
//# sourceMappingURL=ursaColorsInternal.js.map